<template>
  <img :class="{ invert: !darkMode }" :src="`https://creative-content.aftvrsys.com/image-alternatives/light/favicon-128x128.png`" alt />
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'Logo',

  computed: mapState('global', ['darkMode'])
}
</script>

<style lang="scss" scoped>
img.invert {
  filter: invert(1);
}
</style>
